import React, { useEffect, useState } from "react";

import { apiGetRequest } from "helpers/Requests";
import CircularLoader from "components/common/CircularLoader/CircularLoader";
import FeatureOfTheWeekCard from "components/common/FeatureOfTheWeekCard/FeatureOfTheWeekCard";
import "./SystemNews.css";

const FeatureOfTheWeekTab = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [featureOfTheWeek, setFeatureOfTheWeek] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const getFeatureOfTheWeek = async () => {
      try {
        if (isMounted) {
          setIsLoading(true);
        }

        const featureRes = await apiGetRequest(`/sp/feature-of-the-week/show`);

        if (isMounted) {
          if (featureRes && featureRes.status === 200) {
            setFeatureOfTheWeek(
              featureRes.data?.data?.feature_of_the_week || null
            );
          }
          setIsLoading(false);
        }
      } catch (err) {
        if (isMounted) {
          setIsLoading(false);
        }
        console.log(err);
      }
    };

    getFeatureOfTheWeek();

    return () => {
      isMounted = false;
    };
  }, []);

  const hasFeature = Boolean(
    featureOfTheWeek &&
      (featureOfTheWeek.description ||
        featureOfTheWeek.embed_url ||
        featureOfTheWeek.video_url)
  );

  return (
    <div
      className="w-full custom-scroll"
      style={{ maxHeight: "450px", overflowY: "auto" }}
    >
      {isLoading ? (
        <div className="flex flex-col w-full items-center justify-center">
          <CircularLoader
            className="flex justify-center items-center"
            classloader="loader-l"
          />
        </div>
      ) : hasFeature ? (
        <div className="m-2">
          <FeatureOfTheWeekCard
            title={featureOfTheWeek.title || "Feature of the Week"}
            description={featureOfTheWeek.description || ""}
            videoUrl={featureOfTheWeek.video_url || ""}
            embedUrl={featureOfTheWeek.embed_url || null}
          />
        </div>
      ) : (
        <p className="text-sm font-semibold mb-2 text-center">
          No feature of the week available
        </p>
      )}
    </div>
  );
};

export default FeatureOfTheWeekTab;
